<script>
    import CarDayTrace from './CarDayTrace.svelte';

    let cars = [...new Array(35)].map((d,i) => { return i+1 }).concat([101,102,103,104,105,106,107])
    let car = 1
</script>

Car: 
<select bind:value={car}>
    {#each cars as car}
        <option value={car}>{car}</option>
    {/each}
</select><br/>
<table>
    <tr>
        {#each [6,7,8,9,10,11,12] as day}
            <td width=200 height=200><CarDayTrace car={car} day={day} /></td>
        {/each}
    </tr>
    <tr>
        {#each [13,14,15,16,17,18,19] as day}
            <td width=200 height=200><CarDayTrace car={car} day={day} /></td>
        {/each}
    </tr>

</table>